<template>
  <section>
    <ul v-if="matriculas && ready">
      <li v-for="item in matriculas" :key="item.idMatricula">
        <div>
          {{ item.idMatricula }} - {{ item.aluno }}
        </div>
        <div>
          <div title="PUT Plano">
            <mini-spinner v-if="item.loading.put" />
            <fa :icon="['fas','check']" v-else-if="item.done.put" class="ic"/>
          </div>
          <div title="SET Plano">
            <mini-spinner v-if="item.loading.get" />
            <fa :icon="['fas','check']" v-else-if="item.plano" class="ic"/>
          </div>
          <div title="GET Plano">
            <mini-spinner v-if="item.loading.get" />
            <fa :icon="['fas','check']" v-else-if="item.done.get" class="ic"/>
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import MatriculaService from '@/services/matricula.service.js'
import matRui from '@/assets/data/mat_rui.json'
import MiniSpinner from '@/components/utilities/MiniSpinner.vue'

export default {
  components: {
    MiniSpinner
  },
  data () {
    return {
      ready: false,
      matriculas: matRui,
      count: 0,
      getPlanosLoop: null,
      etapa: 'get'
    }
  },
  mounted () {
    if ( this.matriculas ) {
      this.matriculas.map( k => {
        k['loading'] = {
          get: false,
          put: false
        }
        k['done'] = {
          get: false,
          put: false
        }
        k['plano'] = null
        k['response'] = null
      })

      console.log(" this.matriculas:",  this.matriculas)

      this.$nextTick(() => {
        this.ready = true
        this.run()
      })
      
    }
  },
  methods: {
    run () {
      const last = this.matriculas.length - 1
      // const last = 2
      console.log("count:", this.count)
      console.log("last:", last)
      
      console.log("matricula:", this.matriculas[this.count])

      const idMatricula = this.matriculas[this.count].idMatricula
      
      if ( this.count <= last ) {
        if ( idMatricula ) {
          this.getPlanos(this.count,idMatricula)
          this.count++
        }
      } 
    },
    getPlanos (i, m) {
      this.matriculas[i].loading.get = true
      MatriculaService.getPlanosPagamento(m).then(
        response => {
          this.matriculas[i].done.get = true
          this.matriculas[i].loading.get = false
          this.matriculas[i].plano = response.data[0]
          
          this.setPlanos(i,m)
          
          // console.log("response.data:", response.data)
        }
      )
    },
    setPlanos (i, m) {
      this.matriculas[i].loading.put = true
      const p = this.matriculas[i].plano

      MatriculaService.savePlanosPagamento(m,p).then(
        response => {
          this.matriculas[i].done.put = true
          this.matriculas[i].loading.put = false
          this.matriculas[i].response = response.data

          this.$nextTick(() => {
            this.run()
          })
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  section {
    background: $preto-2;
    min-height: 100vh;
    color: $color-secondary;

    ul {
      padding: $mg; margin: 0;

      li {
        list-style: none;
        padding: $hmg_mid;
        display: flex; align-items: center;
        justify-content: space-between;
        border-radius: 5px;
        border: 1px solid rgba(255,255,255,0.2);
        margin-bottom: $mg_mini;

        >div {
          &:last-child {
            display: flex; align-items: center;
            justify-content: flex-end;
            gap: $mg_mini;

            >div {
              border: 1px solid rgba(255,255,255,0.1);
              padding: $mg_mini;
              line-height: 1;
            }

            .ic {
              color: $color-success-2
            }
          }
        }
      }
    }
  }
</style>